if (!customElements.get('variants-slider')) {
    class VariantsSlider extends HTMLElement {
        constructor() {
            super();
            this.slider = this.querySelector('.variants-slider');
            this.sliderItems = this.querySelectorAll('label');
            this.prevButton = this.querySelector('.prev-button');
            this.nextButton = this.querySelector('.next-button');
            this.buttonContent = this.querySelector('.button-content');
            this.totalPages = this.sliderItems.length;
            if (!this.slider || !this.nextButton) return;

            const resizeObserver = new ResizeObserver(entries => this.initPages());
            resizeObserver.observe(this.slider);

            this.slider.addEventListener('scroll', this.update.bind(this));
            this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
            this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
        }

        initPages() {
            if (this.clientWidth * 0.8 < this.slider.scrollWidth) {
                this.buttonContent.classList.add('active');
            } else {
                this.buttonContent.classList.remove('active');
            }
            const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
            this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
            if (sliderItemsToShow.length === 0) return;
            this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
            this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
            this.update();
        }

        update() {
            this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

            if (this.currentPage === 1) {
                this.prevButton.setAttribute('disabled', true);
            } else {
                this.prevButton.removeAttribute('disabled');
            }

            if (this.currentPage === this.totalPages) {
                this.nextButton.setAttribute('disabled', true);
            } else {
                this.nextButton.removeAttribute('disabled');
            }
        }

        onButtonClick(event) {
            event.preventDefault();
            const slideScrollPosition = event.target.classList.contains('next-button') ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
            this.slider.scrollTo({
                left: slideScrollPosition
            });
        }
    }

    customElements.define('variants-slider', VariantsSlider);
}
